
export const formatText = (format: string, text: string, start: number, end: number): string => {
  let formattedText = '';

  switch (format) {
    case 'bold':
      formattedText = text.slice(0, start) + '**' + text.slice(start, end) + '**' + text.slice(end);
      break;
    case 'italic':
      formattedText = text.slice(0, start) + '_' + text.slice(start, end) + '_' + text.slice(end);
      break;
    case 'underline':
      formattedText = text.slice(0, start) + '__' + text.slice(start, end) + '__' + text.slice(end);
      break;
    case 'list':
      const selectedText = text.slice(start, end);
      const lines = selectedText.split('\n');
      const bulletPoints = lines.map(line => `• ${line}`).join('\n');
      formattedText = text.slice(0, start) + bulletPoints + text.slice(end);
      break;
  }

  return formattedText;
};
